const { REACT_APP_HEBI_API_BASE_URL } = process.env;

if (!REACT_APP_HEBI_API_BASE_URL || !REACT_APP_HEBI_API_BASE_URL.length) {
  throw new Error('No API base URL set, have you configured your local .env file?');
}

export {
  REACT_APP_HEBI_API_BASE_URL,
};
